module.exports = __webpack_public_path__ + "static/media/clipboard-text.5d7f1021.svg";